"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SearchWidget_1 = __importDefault(require("./SearchWidget"));
const defaultConfig_1 = require("../../lib/defaultConfig");
const DefaultSearchWidget = (props) => {
    var _a, _b, _c;
    if (!((_a = props.config) === null || _a === void 0 ? void 0 : _a.customer_code)) {
        throw new Error('Customer Code is required');
    }
    // only thing we'll consume is a theme object if it exists
    const config = Object.assign(Object.assign({}, (0, defaultConfig_1.defaultConfig)((_b = props.config) === null || _b === void 0 ? void 0 : _b.theme)), { customer_code: (_c = props.config) === null || _c === void 0 ? void 0 : _c.customer_code });
    return react_1.default.createElement(SearchWidget_1.default, Object.assign({}, props, { config: config }));
};
exports.default = DefaultSearchWidget;
//# sourceMappingURL=DefaultSearchWidget.js.map